export default __webpack_public_path__ + "static/media/hero-caro-mbl-new-2.cbe8f164.png";